import styled from 'styled-components';

export const DetailsPaginationStyles = styled.div`
	overflow: hidden;
	display: flex;
	align-items: center;
	height: 2.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;

	.pagination-button {
		width: 2.5rem;
		height: 100%;
		border: 0;
		border-right: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0;

		&-next {
			border-right: 0;
			border-left: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		}

		&.disabled {
			pointer-events: none;

			> * {
				opacity: 0.3;
			}
		}
	}

	.text-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: 0 0.5rem;
	}
`;
